var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamaskGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 24,
    viewBox: "0 0 138 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_615_248867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.71 12.073C120.982 11.6122 120.173 11.305 119.445 10.921C118.925 10.6964 118.436 10.4127 117.988 10.0762C117.828 9.93546 117.704 9.76249 117.624 9.57003C117.544 9.37757 117.51 9.17051 117.526 8.96413C117.541 8.75775 117.606 8.55731 117.714 8.3776C117.822 8.19788 117.971 8.04348 118.15 7.92576C118.412 7.74578 118.717 7.62978 119.038 7.58799C119.359 7.5462 119.685 7.5799 119.989 7.68612C120.293 7.79234 120.564 7.96782 120.78 8.1971C120.995 8.42639 121.148 8.70244 121.225 9.00096C121.225 9.02133 121.233 9.04086 121.248 9.05527C121.264 9.06967 121.284 9.07776 121.306 9.07776H122.924C123.005 9.07776 123.005 9.07776 123.005 9.00096C122.991 8.56723 122.874 8.142 122.664 7.75657C122.454 7.37113 122.156 7.0353 121.791 6.77376C121.141 6.29567 120.348 6.02665 119.526 6.00576C115.237 6.00576 114.833 10.3066 117.179 11.6122C117.422 11.7658 119.687 12.841 120.497 13.3018C120.864 13.4829 121.144 13.791 121.28 14.1624C121.415 14.5339 121.396 14.9405 121.225 15.2986C121.037 15.6251 120.754 15.893 120.409 16.0702C120.065 16.2474 119.673 16.3261 119.283 16.297C118.88 16.2869 118.489 16.1653 118.159 15.9469C117.828 15.7285 117.572 15.4231 117.422 15.0682C117.362 14.9215 117.334 14.7646 117.341 14.6074C117.341 14.5973 117.339 14.5873 117.335 14.578C117.331 14.5687 117.325 14.5602 117.317 14.5531C117.31 14.5459 117.301 14.5403 117.291 14.5364C117.281 14.5325 117.271 14.5306 117.26 14.5306H115.48C115.469 14.5306 115.459 14.5325 115.449 14.5364C115.439 14.5403 115.43 14.5459 115.423 14.5531C115.415 14.5602 115.409 14.5687 115.405 14.578C115.401 14.5873 115.399 14.5973 115.399 14.6074C115.341 15.0836 115.424 15.5658 115.638 15.9999C115.852 16.4339 116.19 16.8028 116.613 17.065C117.346 17.6236 118.262 17.9223 119.202 17.9098C121.629 17.9098 122.843 16.6042 123.086 15.2986C123.227 14.6919 123.171 14.0589 122.926 13.4831C122.68 12.9072 122.256 12.4155 121.71 12.073V12.073Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4895 6.23616H43.7903C43.7689 6.23616 43.7483 6.24425 43.7331 6.25865C43.718 6.27306 43.7094 6.29259 43.7094 6.31296L42.3339 10.8442C42.3339 10.921 42.253 10.921 42.1721 10.8442L40.7156 6.31296C40.7156 6.29259 40.7071 6.27306 40.6919 6.25865C40.6768 6.24425 40.6562 6.23616 40.6347 6.23616H37.8836C37.8622 6.23616 37.8416 6.24425 37.8264 6.25865C37.8113 6.27306 37.8027 6.29259 37.8027 6.31296V17.833C37.8027 17.8533 37.8113 17.8729 37.8264 17.8873C37.8416 17.9017 37.8622 17.9098 37.8836 17.9098H39.7447C39.7661 17.9098 39.7867 17.9017 39.8019 17.8873C39.817 17.8729 39.8256 17.8533 39.8256 17.833V9.07776C39.8256 9.00096 39.9065 9.00096 39.9874 9.07776L41.4438 13.609L41.5248 13.9162C41.5248 13.9365 41.5333 13.9561 41.5485 13.9705C41.5636 13.9849 41.5842 13.993 41.6057 13.993H42.9812C43.0027 13.993 43.0232 13.9849 43.0384 13.9705C43.0536 13.9561 43.0621 13.9365 43.0621 13.9162L43.143 13.609L44.5995 9.07776C44.5995 9.00096 44.7613 9.00096 44.7613 9.07776V17.833C44.7613 17.8533 44.7698 17.8729 44.785 17.8873C44.8002 17.9017 44.8208 17.9098 44.8422 17.9098H46.6223C46.6438 17.9098 46.6644 17.9017 46.6795 17.8873C46.6947 17.8729 46.7032 17.8533 46.7032 17.833V6.31296C46.7032 6.29259 46.6947 6.27306 46.6795 6.25865C46.6644 6.24425 46.6438 6.23616 46.6223 6.23616H45.4895Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7659 6.23616L93.2286 10.7674C93.2286 10.8442 93.1477 10.8442 93.0667 10.7674L91.6103 6.23616C91.6103 6.21579 91.6018 6.19626 91.5866 6.18186C91.5714 6.16745 91.5508 6.15936 91.5294 6.15936H88.8592C88.8378 6.15936 88.8172 6.16745 88.802 6.18186C88.7868 6.19626 88.7783 6.21579 88.7783 6.23616V17.7562C88.7783 17.7765 88.7868 17.7961 88.802 17.8105C88.8172 17.8249 88.8378 17.833 88.8592 17.833H90.6393C90.6608 17.833 90.6814 17.8249 90.6965 17.8105C90.7117 17.7961 90.7202 17.7765 90.7202 17.7562V9.07776C90.7202 9.00096 90.8012 9.00096 90.8821 9.07776L92.3385 13.609L92.4194 13.9162C92.4194 13.9365 92.428 13.9561 92.4431 13.9705C92.4583 13.9849 92.4789 13.993 92.5003 13.993H93.8759C93.8973 13.993 93.9179 13.9849 93.9331 13.9705C93.9483 13.9561 93.9568 13.9365 93.9568 13.9162L94.0377 13.609L95.4941 9.07776C95.4941 9.00096 95.656 9.00096 95.656 9.07776V17.833C95.656 17.8533 95.6645 17.8729 95.6797 17.8873C95.6948 17.9017 95.7154 17.9098 95.7369 17.9098H97.517C97.5384 17.9098 97.559 17.9017 97.5742 17.8873C97.5894 17.8729 97.5979 17.8533 97.5979 17.833V6.31296C97.5979 6.29259 97.5894 6.27306 97.5742 6.25866C97.559 6.24425 97.5384 6.23616 97.517 6.23616H94.7659Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.191 6.23616H63.9378C63.9164 6.23616 63.8958 6.24425 63.8806 6.25865C63.8655 6.27306 63.8569 6.29259 63.8569 6.31296V7.77216C63.8569 7.79253 63.8655 7.81206 63.8806 7.82647C63.8958 7.84087 63.9164 7.84896 63.9378 7.84896H67.1744V17.833C67.1744 17.8533 67.1829 17.8729 67.1981 17.8873C67.2133 17.9017 67.2338 17.9098 67.2553 17.9098H68.8736C68.895 17.9098 68.9156 17.9017 68.9308 17.8873C68.946 17.8729 68.9545 17.8533 68.9545 17.833V7.84896H72.191C72.2125 7.84896 72.2331 7.84087 72.2482 7.82647C72.2634 7.81206 72.2719 7.79253 72.2719 7.77216L72.191 6.23616V6.23616Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5481 17.9098H84.1663C84.177 17.9098 84.1875 17.9078 84.1973 17.9039C84.2071 17.9001 84.216 17.8944 84.2235 17.8873C84.2311 17.8801 84.237 17.8717 84.2411 17.8623C84.2452 17.853 84.2472 17.843 84.2472 17.833L80.9298 6.31296C80.9298 6.29259 80.9213 6.27306 80.9061 6.25865C80.8909 6.24425 80.8703 6.23616 80.8489 6.23616H78.5024C78.4809 6.23616 78.4603 6.24425 78.4452 6.25865C78.43 6.27306 78.4215 6.29259 78.4215 6.31296L75.104 17.833C75.104 17.9098 75.104 17.9098 75.1849 17.9098H76.8032C76.8247 17.9098 76.8452 17.9017 76.8604 17.8873C76.8756 17.8729 76.8841 17.8533 76.8841 17.833L77.8551 14.4538C77.8551 14.4334 77.8636 14.4139 77.8788 14.3995C77.8939 14.3851 77.9145 14.377 77.936 14.377H81.4962C81.5176 14.377 81.5382 14.3851 81.5534 14.3995C81.5686 14.4139 81.5771 14.4334 81.5771 14.4538L82.5481 17.9098C82.4671 17.833 82.4671 17.9098 82.5481 17.9098ZM78.3405 12.7642L79.6352 8.30976C79.6352 8.23296 79.7161 8.23296 79.797 8.30976L81.0916 12.7642C81.0916 12.841 81.0916 12.841 81.0107 12.841H78.4215C78.3406 12.9178 78.3405 12.841 78.3405 12.7642Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.735 17.9098H111.353C111.364 17.9098 111.374 17.9078 111.384 17.9039C111.394 17.9001 111.403 17.8944 111.411 17.8873C111.418 17.8801 111.424 17.8717 111.428 17.8623C111.432 17.853 111.434 17.843 111.434 17.833L108.117 6.31296C108.117 6.29259 108.108 6.27306 108.093 6.25865C108.078 6.24425 108.057 6.23616 108.036 6.23616H105.689C105.668 6.23616 105.647 6.24425 105.632 6.25865C105.617 6.27306 105.608 6.29259 105.608 6.31296L102.291 17.833C102.291 17.9098 102.291 17.9098 102.372 17.9098H103.99C104.001 17.9098 104.011 17.9078 104.021 17.9039C104.031 17.9001 104.04 17.8944 104.047 17.8873C104.055 17.8801 104.061 17.8717 104.065 17.8623C104.069 17.853 104.071 17.843 104.071 17.833L105.042 14.4538C105.042 14.4334 105.051 14.4139 105.066 14.3995C105.081 14.3851 105.102 14.377 105.123 14.377H108.683C108.705 14.377 108.725 14.3851 108.74 14.3995C108.756 14.4139 108.764 14.4334 108.764 14.4538L109.735 17.9098V17.9098ZM105.528 12.7642L106.822 8.30976C106.822 8.23296 106.903 8.23296 106.984 8.30976L108.279 12.7642C108.279 12.841 108.279 12.841 108.198 12.841H105.608C105.608 12.9178 105.528 12.841 105.528 12.7642Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6618 16.1434V12.6106C53.6618 12.5902 53.6703 12.5707 53.6855 12.5563C53.7007 12.5419 53.7212 12.5338 53.7427 12.5338H58.4357C58.4463 12.5338 58.4568 12.5318 58.4667 12.5279C58.4765 12.5241 58.4854 12.5184 58.4929 12.5113C58.5004 12.5041 58.5064 12.4957 58.5104 12.4863C58.5145 12.477 58.5166 12.467 58.5166 12.457V10.9978C58.5166 10.9774 58.5081 10.9579 58.4929 10.9435C58.4777 10.9291 58.4571 10.921 58.4357 10.921H53.7427C53.7212 10.921 53.7007 10.9129 53.6855 10.8985C53.6703 10.8841 53.6618 10.8645 53.6618 10.8442V7.77216C53.6618 7.75179 53.6703 7.73226 53.6855 7.71785C53.7007 7.70345 53.7212 7.69536 53.7427 7.69536H59.083C59.1045 7.69536 59.125 7.68727 59.1402 7.67287C59.1554 7.65846 59.1639 7.63893 59.1639 7.61856V6.31296C59.1639 6.29259 59.1554 6.27306 59.1402 6.25865C59.125 6.24425 59.1045 6.23616 59.083 6.23616H51.8817C51.8602 6.23616 51.8397 6.24425 51.8245 6.25865C51.8093 6.27306 51.8008 6.29259 51.8008 6.31296V17.7562C51.8008 17.7765 51.8093 17.7961 51.8245 17.8105C51.8397 17.8249 51.8602 17.833 51.8817 17.833H59.2448C59.2663 17.833 59.2869 17.8249 59.302 17.8105C59.3172 17.7961 59.3257 17.7765 59.3257 17.7562V16.2202C59.3257 16.1998 59.3172 16.1803 59.302 16.1659C59.2869 16.1514 59.2663 16.1434 59.2448 16.1434H53.6618Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.731 17.7562L131.662 11.8426V11.7658L137.165 6.38976C137.246 6.31296 137.165 6.31296 137.084 6.31296H134.737L130.125 10.8442C130.044 10.921 130.044 10.8442 130.044 10.7674V6.31296C130.044 6.29259 130.036 6.27306 130.021 6.25865C130.005 6.24425 129.985 6.23616 129.963 6.23616H128.183C128.162 6.23616 128.141 6.24425 128.126 6.25865C128.111 6.27306 128.102 6.29259 128.102 6.31296V17.833C128.102 17.8533 128.111 17.8729 128.126 17.8873C128.141 17.9017 128.162 17.9098 128.183 17.9098H129.963C129.985 17.9098 130.005 17.9017 130.021 17.8873C130.036 17.8729 130.044 17.8533 130.044 17.833V12.7642C130.044 12.7438 130.053 12.7243 130.068 12.7099C130.083 12.6955 130.104 12.6874 130.125 12.6874L135.385 17.833H137.731V17.7562Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9893 0.0921631L15.3896 7.54176L17.3316 3.16416L25.9893 0.0921631Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47266 0.0921631L11.9914 7.61856L10.1304 3.16416L1.47266 0.0921631Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1057 17.3722L19.2737 21.4426L25.3422 23.0554L27.0414 17.449L22.1057 17.3722Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.339844 17.5258L2.03903 23.1322L8.10754 21.5194L5.27557 17.449L0.339844 17.5258Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7839 10.4602L6.08472 12.841L12.0723 13.0714L11.9105 6.92736L7.7839 10.4602Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6782 10.4602L15.4707 6.92736L15.3088 13.1482L21.2964 12.9178L19.6782 10.4602Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10742 21.5194L11.7485 19.8298L8.5929 17.5258L8.10742 21.5194Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7134 19.8298L19.3545 21.5194L18.869 17.5258L15.7134 19.8298Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2737 21.5194L15.6326 19.8298L15.9562 22.057V22.9786L19.2737 21.5194Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10742 21.5194L11.5058 23.0554V22.1338L11.8294 19.9066L8.10742 21.5194Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.506 16.0666L8.51221 15.2218L10.616 14.3002L11.506 16.0666Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8752 16.0666L16.7653 14.3002L18.869 15.2218L15.8752 16.0666Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10761 21.5194L8.59309 17.449L5.27563 17.5258L8.10761 21.5194Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7881 17.3722L19.2736 21.4426L22.1055 17.449L18.7881 17.3722Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2964 12.9178L15.3088 13.1482L15.8752 16.0666L16.7653 14.3002L18.869 15.2218L21.2964 12.9178Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51212 15.2218L10.6159 14.3002L11.5059 16.0666L12.0723 13.1482L6.08472 12.9178L8.51212 15.2218Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08472 12.9178L8.59304 17.6026L8.51212 15.2986L6.08472 12.9178Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.869 15.2218L18.7881 17.5258L21.2964 12.841L18.869 15.2218Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0723 13.1482L11.5059 16.0666L12.2341 19.5226L12.3959 14.9914L12.0723 13.1482Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3088 13.1482L14.9851 14.9914L15.1469 19.5226L15.8752 16.0666L15.3088 13.1482Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8752 16.0666L15.147 19.5226L15.6325 19.8298L18.7881 17.5258L18.869 15.2218L15.8752 16.0666Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51221 15.2218L8.59312 17.5258L11.7487 19.8298L12.2342 19.5226L11.506 16.0666L8.51221 15.2218Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9561 22.9786V22.057L15.7134 21.8266H11.6677L11.425 22.057V22.9786L8.02661 21.4426L9.24031 22.3642L11.5868 23.9002H15.7134L18.1408 22.3642L19.2736 21.4426L15.9561 22.9786Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7135 19.8298L15.228 19.5226H12.2342L11.7487 19.8298L11.425 22.057L11.6678 21.8266H15.7135L15.9562 22.057L15.7135 19.8298Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.394 8.07936L27.284 3.93216L25.9894 0.0921631L15.7134 7.31136L19.6781 10.4602L25.2612 11.9962L26.4749 10.6138L25.9085 10.2298L26.7985 9.46176L26.1512 9.00096L27.0413 8.38656L26.394 8.07936Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.097168 3.93216L0.987217 8.07936L0.420822 8.46336L1.31087 9.07776L0.663563 9.53856L1.55361 10.3066L0.987217 10.6906L2.20092 12.073L7.78396 10.537L11.7487 7.38816L1.4727 0.0921631L0.097168 3.93216Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1803 11.9962L19.5972 10.4602L21.2964 12.841L18.7881 17.5258L22.1055 17.449H27.0413L25.1803 11.9962Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78389 10.4602L2.20086 11.9962L0.339844 17.449H5.27557L8.59303 17.5258L6.08471 12.841L7.78389 10.4602Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3089 13.1482L15.6326 7.31136L17.2509 3.16416H10.0496L11.6678 7.31136L11.9915 13.1482L12.1533 14.9914V19.5226H15.1471V14.9914L15.3089 13.1482Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_248867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.739,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskGroup);
export default __webpack_public_path__ + "static/media/metamask-group.ea2a4a67a03f72520e875518d8d7a4c5.svg";
export { ForwardRef as ReactComponent };